module.exports = "pegasus_template/assets/tech/valentine/100.png";